<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" class="titleLarge d-flex align-center">
        <p class="opacity87">{{ $t('views.topo.title') }}</p>
      </v-col>
    </v-row>

    <RightBarElevationGraph :data="elevationDataBuffer" />
    <RightBarSlopeGraph class="mt-3" :data="slopeDataBuffer" />
  </v-container>
</template>

<script setup lang="ts">
// Components Import
import IncidentStore from '@/stores/incidentStore'

import RightBarElevationGraph from '../RightBarElevationGraph.vue'
import RightBarSlopeGraph from '../RightBarSlopeGraph.vue'

// Store Import
const incidentStore = IncidentStore()

// Props
const props = defineProps<{ buffer: string }>()

const elevationDataBuffer = incidentStore.getIncidentCalculations('Topography', 'Elevation', props.buffer)
const slopeDataBuffer = incidentStore.getIncidentCalculations('Topography', 'Slope', props.buffer)
</script>

<style scoped lang="scss">
:deep(.v-expansion-panel) {
  background-color: rgb(var(--v-theme-background));
  color: white;
}
:deep(.v-expansion-panel-title) {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
